import React, { useState } from 'react';
import { Modal, Form } from 'antd';
import { Button, Input } from '@gamesb42/ui-kit';
import { useHistory } from 'react-router-dom';
import { resetPassword } from '../../../api/auth';
import appStore from '../../../store/App';
import EmailSentModal from '../../Login/components/EmailSentModal';

const ExpiredLinkScreen: React.FC = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [sentEmail, setSentEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRequestNewLink = async (values: { email: string }) => {
    setLoading(true);
    try {
      await resetPassword({ email: values.email });

      // Закрываем модалку с формой и показываем модалку успеха
      setShowEmailModal(false);
      setSentEmail(values.email);
      setShowSuccessModal(true);
      form.resetFields();
    } catch (error: any) {
      console.error('Reset password error:', error);
      const errorMessage =
        error?.response?.data?.detail ||
        'Failed to send password reset email. Please try again.';
      appStore.setNotification({
        type: 'error',
        title: errorMessage,
        width: 450,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    // Возвращаемся на страницу логина
    history.push('/login');
  };

  return (
    <div style={{ textAlign: 'left' }}>
      <h2
        style={{
          marginBottom: '20px',
          color: '#090909',
          fontSize: '32px',
          fontWeight: 700,
          lineHeight: '40px',
          fontFamily: 'Muller',
        }}
      >
        Password reset link expired
      </h2>

      <p
        style={{
          display: 'block',
          marginBottom: '32px',
          color: '#606176',
          fontSize: '16px',
        }}
      >
        For your security, password reset links are only valid for a limited
        time
      </p>

      <Button
        type="primary"
        size="large"
        violet
        style={{
          color: '#fff',
          width: '178px',
          marginBottom: '24px',
        }}
        onClick={() => setShowEmailModal(true)}
      >
        Request a new link
      </Button>

      <div>
        <span
          onClick={() => history.push('/login')}
          style={{
            color: '#5227cb',
            fontSize: '16px',
            cursor: 'pointer',
          }}
        >
          Back to Sign In
        </span>
      </div>

      {/* Модалка для ввода email */}
      <Modal
        open={showEmailModal}
        onCancel={() => {
          setShowEmailModal(false);
          form.resetFields();
        }}
        footer={null}
        width={520}
        centered
        okButtonProps={{ style: { display: 'none' } }}
      >
        <div style={{ padding: '24px 0' }}>
          <h3
            style={{
              marginBottom: '16px',
              color: '#090909',
              fontSize: '24px',
              fontFamily: 'Muller',
            }}
          >
            Request a new link
          </h3>

          <p
            style={{
              display: 'block',
              marginBottom: '32px',
              color: '#606176',
              fontSize: '14px',
            }}
          >
            Enter your email address and we'll send you a new password reset
            link.
          </p>

          <Form form={form} layout="vertical" onFinish={handleRequestNewLink}>
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please input your email!' },
                { type: 'email', message: 'Please enter a valid email!' },
              ]}
            >
              <Input
                label="Email"
                placeholder="Enter your email"
                size="large"
              />
            </Form.Item>

            <div
              style={{
                display: 'flex',
                gap: '16px',
                justifyContent: 'flex-end',
                marginTop: '32px',
              }}
            >
              <Button
                size="large"
                onClick={() => {
                  setShowEmailModal(false);
                  form.resetFields();
                }}
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                size="large"
                violet
                style={{ color: '#fff' }}
              >
                Send Reset Link
              </Button>
            </div>
          </Form>
        </div>
      </Modal>

      {/* Модалка успешной отправки */}
      <EmailSentModal
        visible={showSuccessModal}
        email={sentEmail}
        onClose={handleSuccessModalClose}
      />
    </div>
  );
};

export default ExpiredLinkScreen;
